module.exports = __webpack_public_path__ + "img/seven7Orange.d80da22d.jpg";